
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/en/home",
      function () {
        return require("private-next-pages/nl/en/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/en/home"])
      });
    }
  